import React, { memo, useEffect, useState } from "react";
import styles from "./StoreFrontLayoutHeader.module.scss";
import { MenuIcon, SearchIcon, ShoppingCart } from "../../../../assets/icons";
import StoreSearch from "./StoreSearch";
import { useNavigate } from "react-router-dom";
import { ApplicationRoutes } from "../../../../routes";
import { useLazyGetCustomerInfoQuery } from "../../../../service/customer-service";
import { toast } from "react-toastify";
import StoreFrontUserHeader from "./StoreFrontUserHeader";
import { useSelector } from "react-redux";
import { RootState } from "../../../../stores/store";

type Props = {};

const StoreFrontLayoutHeader: React.FC<Props> = memo((props: Props) => {
	const navigate = useNavigate();
	const username = useSelector((state: RootState) => state.user.userName) ?? "";

	const [ isSearchBarVisible, setIsSearchBarVisible ] = useState(false);

	const [getCustomerInfo] = useLazyGetCustomerInfoQuery();

	function navigateToLandingPage() {
        navigate(ApplicationRoutes.LANDING_PAGE);
    }

	const navigateToWishlist = () =>{
		navigate(ApplicationRoutes.WISHLIST)
	}

	useEffect(() => {
		if (!sessionStorage.getItem("token")) return;
		getCustomerInfo(undefined, true)
		.unwrap()
		.then()
		.catch(
			(err) => {
				if (err.status === 403) return;
				
				toast.error(err.data?.title || "Something went wrong");
			}
		);
	}, []);

	return (
		<div className={styles.header}>
			<button className={styles.logoContainer} onClick={navigateToLandingPage}>
				<img src="../../../images/solar-marketplace-logo.svg" alt="Logo" />
			</button>
			<div className={`${styles.search} ${isSearchBarVisible ? styles.barVisible : null}`}>
				<StoreSearch />
			</div>
			<StoreFrontUserHeader userName={username} />
			<button onClick={navigateToWishlist} className={`standardButton ${styles.cartButton}`}>
				<ShoppingCart/> Wishlist 
				{/* <span className={styles.cartAmountPill}>99+</span> */}
			</button>
			<button className={`standardButton ${styles.searchButton}`} onClick={() => setIsSearchBarVisible(prev => !prev)}>
				<SearchIcon />
			</button>
			<button className={`standardButton ${styles.menuButton}`}>
				<MenuIcon />
			</button>
		</div>
	);
});

export default StoreFrontLayoutHeader;
